import type { IconSvgObject } from './types';

const CalendarRemove02Icon: IconSvgObject = [
  ["path", { d: "M14.4999 13.5L11.9999 16M11.9999 16L9.49988 18.5M11.9999 16L14.4999 18.5M11.9999 16L9.49988 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.4999 2V6M7.49988 2V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.9999 4H4.99988C3.89531 4 2.99988 4.89543 2.99988 6V20C2.99988 21.1046 3.89531 22 4.99988 22H18.9999C20.1044 22 20.9999 21.1046 20.9999 20V6C20.9999 4.89543 20.1044 4 18.9999 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2.99988 10H20.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CalendarRemove02Icon;
